/* Sinneszauber - Szene "Warum Olfazeta": Text -> Ueberschrift -> Flakons fuellen sich und spruehen.
   Flakons 1-3 im Theme-Profil, Flakon 4 = Olfazeta Luxury (Beispiel Nr. 141 Sands of Time, Spruehinhalt nach dessen Duftpyramide).
   Antippen eines Flakons laesst ihn spruehen. */
(function () {
  function init(root) {
  if (root.dataset.flReady) return;
  root.dataset.flReady = '1';

    const DATA = JSON.parse(root.querySelector('script.fl-data').textContent);
    const uid = 'fl' + Math.random().toString(36).slice(2, 7);
    const MAX = Math.max(30, ...DATA.map((d) => d.to));
    const stage = root.querySelector('.fl-stage');
  
    // Flakons 1-3: Profil wie im Theme (Kappe, Hals, Glas); Duese rechts an der Kappe
    const themeSVG = (i) => `
      <svg class="fl-bottle" viewBox="0 0 80 150" aria-hidden="true" data-nx="57.5" data-ny="11">
        <defs><clipPath id="${uid}cl${i}"><path d="M15 32h50a7 7 0 0 1 7 7v99a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V39a7 7 0 0 1 7-7Z"/></clipPath></defs>
        <rect x="33" y="20" width="14" height="10" fill="#E1D8CB"/>
        <path d="M14 30h52a8 8 0 0 1 8 8v100a10 10 0 0 1-10 10H16a10 10 0 0 1-10-10V38a8 8 0 0 1 8-8Z" fill="#fff" stroke="#E1D8CB" stroke-width="2"/>
        <g clip-path="url(#${uid}cl${i})"><rect class="fl-liquid" x="6" y="${146 - 114 * DATA[i].to / MAX}" width="68" height="${114 * DATA[i].to / MAX}" fill="#56613A" fill-opacity="${[.45, .6, .8][i]}"/></g>
        <rect class="fl-shine" x="14" y="40" width="5" height="70" rx="2.5" fill="#fff"/>
        <g class="fl-pump"><rect x="28" y="2" width="24" height="18" rx="3" fill="#8A8590"/><rect x="52" y="8.5" width="5" height="5" rx="1.2" fill="#6F6A74"/></g>
      </svg>`;
    // Flakon 4: Olfazeta Luxury nach dem Produktfoto Nr. 141 "Sands of Time":
    // breite Kappe mit leicht abgeschraegter Oberkante, darunter schraeg zulaufender Uebergang,
    // schmaler Ring (Hals), Koerper mit abgeschraegten Schultern/Ecken, gerahmtes Etikett, Rillen unten
    const luxSVG = (i) => `
      <svg class="fl-bottle lux" viewBox="0 0 80 150" aria-hidden="true" data-nx="68.6" data-ny="14.5">
        <defs>
          <linearGradient id="${uid}lg${i}" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stop-color="#B08433"/><stop offset=".3" stop-color="#F1D78E"/><stop offset=".55" stop-color="#D8B25E"/><stop offset=".8" stop-color="#C39A45"/><stop offset="1" stop-color="#94692A"/>
          </linearGradient>
          <linearGradient id="${uid}lt${i}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#F7E6B0"/><stop offset="1" stop-color="#D9B866"/></linearGradient>
          <linearGradient id="${uid}ll${i}" x1="0" y1="1" x2="0" y2="0"><stop offset="0" stop-color="#8E3A1C"/><stop offset="1" stop-color="#D9893F"/></linearGradient>
          <clipPath id="${uid}lb${i}"><path d="M20.2 42.4h39.6L70 49v91l-6 6H16l-6-6V49Z"/></clipPath>
        </defs>
        <!-- Ring / Hals -->
        <rect x="20.2" y="32.4" width="39.6" height="10" fill="url(#${uid}lg${i})" stroke="#94692A" stroke-width=".5"/>
        <rect x="20.2" y="32.4" width="39.6" height="1.6" fill="rgba(60,40,10,.3)"/>
        <!-- Koerper -->
        <path d="M20.2 42.4h39.6L70 49v91l-6 6H16l-6-6V49Z" fill="url(#${uid}lg${i})" stroke="#94692A" stroke-width=".6"/>
        <g clip-path="url(#${uid}lb${i})">
          <rect class="fl-liquid" x="10" y="${146 - 104 * DATA[i].to / MAX}" width="60" height="${104 * DATA[i].to / MAX}" fill="url(#${uid}ll${i})" fill-opacity=".5"/>
          <g stroke="rgba(110,76,30,.42)" stroke-width=".8">${Array.from({ length: 19 }, (_, k) => `<line x1="${12 + k * 3}" y1="106" x2="${12 + k * 3}" y2="146"/>`).join('')}</g>
        </g>
        <!-- Etikett mit feinem Rahmen -->
        <rect x="16" y="58" width="48" height="42" fill="rgba(255,246,215,.45)" stroke="#94692A" stroke-width=".7"/>
        <rect x="17.6" y="59.6" width="44.8" height="38.8" fill="none" stroke="rgba(148,105,42,.6)" stroke-width=".4"/>
        <text x="40" y="74" text-anchor="middle" font-family="Bodoni Moda, serif" font-size="9" fill="#2E2410">olfazeta</text>
        <text x="40" y="83" text-anchor="middle" font-family="Figtree, sans-serif" font-size="4.6" letter-spacing=".6" fill="#2E2410">LUXURY</text>
        <text x="40" y="89" text-anchor="middle" font-family="Figtree, sans-serif" font-size="2.9" letter-spacing=".4" fill="#2E2410">EXTRAIT DE PARFUM</text>
        <text x="40" y="95" text-anchor="middle" font-family="Figtree, sans-serif" font-size="2.6" letter-spacing=".2" fill="#2E2410">${(DATA[i].example || "").toUpperCase()}</text>
        <rect x="13" y="50" width="2.6" height="54" rx="1.3" fill="rgba(255,255,255,.4)"/>
        <g class="fl-pump">
          <!-- Kappe: liegt vor dem Ring, damit sie beim Druecken davor bleibt -->
          <path d="M14 4h52l2.1 2.4V25l-8.3 7.4H20.2L11.9 25V6.4Z" fill="url(#${uid}lg${i})" stroke="#94692A" stroke-width=".6"/>
          <path d="M14 4h52l2.1 2.4H11.9Z" fill="url(#${uid}lt${i})"/>
          <path d="M11.9 25h56.2l-8.3 7.4H20.2Z" fill="rgba(70,45,10,.22)"/>
          <rect x="11.9" y="6.4" width="56.2" height="1.2" fill="rgba(255,255,255,.35)"/>
        </g>
      </svg>`;
    const bottleSVG = (i, hl) => (hl ? luxSVG(i) : themeSVG(i));
  
    stage.innerHTML = DATA.map((d, i) => `
      <div class="fl-flask${d.hl ? ' is-hl' : ''}" data-i="${i}" role="button" tabindex="0" aria-label="${d.name}: ${d.from} bis ${d.to} Prozent Parf\u00fcm\u00f6l \u2013 antippen zum Spr\u00fchen">
        <div class="fl-box">${d.hl ? '<span class="fl-badge">Am intensivsten</span>' : ''}${bottleSVG(i, d.hl)}</div>
        <div class="fl-pct" data-pct>0 %</div>
        <div class="fl-name">${d.name}</div>
        <div class="fl-meter"><i></i></div>${d.hl && d.example ? `<div class="fl-example">Beispiel: <b>${d.example}</b></div>` : ''}
      </div>`).join('');
  
    const flasks = [...stage.querySelectorAll('.fl-flask')];
  
    /* ---------- Spruehnebel: ein gemeinsamer Canvas ueber allen Flakons ---------- */
    // Staerke 0..1 je nach Parfuemoel-Anteil: mehr Troepfchen, weiter, dichter, laenger in der Luft
    const strength = (d) => d.to / MAX;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);
    const cv = document.createElement('canvas');
    cv.className = 'fl-mist';
    stage.appendChild(cv);
    const ctx = cv.getContext('2d');
    // weicher Troepfchen-Sprite (vorberechnet, sieht nach feinem Nebel aus)
    const sprite = (rgb) => {
      const c = document.createElement('canvas'); c.width = c.height = 64;
      const g = c.getContext('2d'), gr = g.createRadialGradient(32, 32, 0, 32, 32, 32);
      gr.addColorStop(0, `rgba(${rgb},1)`); gr.addColorStop(.45, `rgba(${rgb},.55)`); gr.addColorStop(1, `rgba(${rgb},0)`);
      g.fillStyle = gr; g.fillRect(0, 0, 64, 64); return c;
    };
    const SPR = { gold: sprite('201,163,78'), amber: sprite('214,128,58') };
    // Frische-Akzente: Zitrone, Orange, Beere, Bluete, Rosenblatt, Minzblatt, Funkeln
    const mk = (draw) => { const c = document.createElement('canvas'); c.width = c.height = 64; draw(c.getContext('2d')); return c; };
    const FRESH = {
      lemon: mk((g) => {
        g.translate(32, 32);
        g.fillStyle = '#F2D23C'; g.beginPath(); g.arc(0, 0, 28, 0, 7); g.fill();
        g.fillStyle = '#FBEA8C'; g.beginPath(); g.arc(0, 0, 23, 0, 7); g.fill();
        g.strokeStyle = '#F2D23C'; g.lineWidth = 2.4;
        for (let i = 0; i < 8; i++) { const a = i * Math.PI / 4; g.beginPath(); g.moveTo(0, 0); g.lineTo(Math.cos(a) * 22, Math.sin(a) * 22); g.stroke(); }
        g.fillStyle = '#FFF6C8'; g.beginPath(); g.arc(0, 0, 3, 0, 7); g.fill();
      }),
      leaf: mk((g) => {
        g.translate(32, 32); g.rotate(-0.6);
        g.fillStyle = '#5FAE6E'; g.beginPath(); g.moveTo(0, -28); g.quadraticCurveTo(22, 0, 0, 28); g.quadraticCurveTo(-22, 0, 0, -28); g.fill();
        g.strokeStyle = 'rgba(255,255,255,.55)'; g.lineWidth = 2; g.beginPath(); g.moveTo(0, -22); g.lineTo(0, 24); g.stroke();
      }),
      orange: mk((g) => {
        g.translate(32, 32);
        g.fillStyle = '#EE8A2A'; g.beginPath(); g.arc(0, 0, 28, 0, 7); g.fill();
        g.fillStyle = '#FFC266'; g.beginPath(); g.arc(0, 0, 23, 0, 7); g.fill();
        g.strokeStyle = '#EE8A2A'; g.lineWidth = 2.4;
        for (let i = 0; i < 9; i++) { const a = i * Math.PI * 2 / 9; g.beginPath(); g.moveTo(0, 0); g.lineTo(Math.cos(a) * 22, Math.sin(a) * 22); g.stroke(); }
      }),
      berry: mk((g) => {
        g.fillStyle = '#C8304A';
        [[32, 22], [22, 30], [42, 30], [26, 41], [38, 41], [32, 50], [32, 34]].forEach(([x, y]) => { g.beginPath(); g.arc(x, y, 8.5, 0, 7); g.fill(); });
        g.fillStyle = 'rgba(255,255,255,.45)';
        [[29, 19], [19, 27], [39, 27], [29, 31]].forEach(([x, y]) => { g.beginPath(); g.arc(x, y, 2.4, 0, 7); g.fill(); });
        g.fillStyle = '#5FAE6E'; g.beginPath(); g.moveTo(32, 14); g.lineTo(24, 8); g.lineTo(32, 11); g.lineTo(40, 8); g.closePath(); g.fill();
      }),
      blossom: mk((g) => {
        g.translate(32, 32);
        g.fillStyle = '#F2A7C3';
        for (let i = 0; i < 5; i++) { g.save(); g.rotate(i * Math.PI * 2 / 5); g.beginPath(); g.ellipse(0, -15, 10, 15, 0, 0, 7); g.fill(); g.restore(); }
        g.fillStyle = '#F6D36B'; g.beginPath(); g.arc(0, 0, 7, 0, 7); g.fill();
      }),
      petal: mk((g) => {
        g.translate(32, 32); g.rotate(0.5);
        g.fillStyle = '#D9506E'; g.beginPath(); g.moveTo(0, -26); g.bezierCurveTo(24, -14, 18, 18, 0, 26); g.bezierCurveTo(-18, 18, -24, -14, 0, -26); g.fill();
        g.fillStyle = 'rgba(255,255,255,.25)'; g.beginPath(); g.ellipse(-5, -6, 5, 12, 0, 0, 7); g.fill();
      }),
      strawberry: mk((g) => {
        g.fillStyle = '#D9283E'; g.beginPath(); g.moveTo(32, 58); g.bezierCurveTo(8, 40, 8, 18, 32, 18); g.bezierCurveTo(56, 18, 56, 40, 32, 58); g.fill();
        g.fillStyle = '#FFE08A'; [[24, 28], [32, 26], [40, 28], [22, 37], [30, 35], [38, 35], [44, 37], [27, 44], [35, 44], [31, 51]].forEach(([x, y]) => { g.beginPath(); g.ellipse(x, y, 1.2, 1.8, 0, 0, 7); g.fill(); });
        g.fillStyle = '#4E9A4E'; g.beginPath(); g.moveTo(32, 20); for (let i = 0; i < 5; i++) { const a = Math.PI + i * Math.PI / 4; g.lineTo(32 + Math.cos(a) * 14, 18 + Math.sin(a) * 6); g.lineTo(32 + Math.cos(a + .4) * 4, 18 + Math.sin(a + .4) * 2); } g.fill();
      }),
      apple: mk((g) => {
        g.fillStyle = '#C7343A'; g.beginPath(); g.moveTo(32, 20); g.bezierCurveTo(52, 8, 62, 32, 50, 50); g.bezierCurveTo(44, 58, 36, 54, 32, 56); g.bezierCurveTo(28, 54, 20, 58, 14, 50); g.bezierCurveTo(2, 32, 12, 8, 32, 20); g.fill();
        g.fillStyle = 'rgba(255,255,255,.35)'; g.beginPath(); g.ellipse(22, 30, 4, 7, -.4, 0, 7); g.fill();
        g.strokeStyle = '#6B4A2A'; g.lineWidth = 3; g.beginPath(); g.moveTo(32, 21); g.lineTo(34, 9); g.stroke();
        g.fillStyle = '#5FAE6E'; g.beginPath(); g.ellipse(41, 12, 8, 4, -.5, 0, 7); g.fill();
      }),
      pineapple: mk((g) => {
        g.fillStyle = '#F2C230'; g.beginPath(); g.moveTo(10, 56); g.lineTo(32, 14); g.lineTo(54, 56); g.closePath(); g.fill();
        g.strokeStyle = '#D69A1E'; g.lineWidth = 2; g.beginPath(); g.moveTo(10, 56); g.lineTo(54, 56); g.stroke();
        g.fillStyle = '#FFE58A'; g.beginPath(); g.moveTo(32, 30); g.lineTo(44, 54); g.lineTo(20, 54); g.closePath(); g.fill();
        g.fillStyle = 'rgba(160,100,20,.6)'; [[28, 36], [36, 36], [24, 46], [32, 46], [40, 46]].forEach(([x, y]) => { g.beginPath(); g.arc(x, y, 1.6, 0, 7); g.fill(); });
      }),
      peach: mk((g) => {
        const gr = g.createRadialGradient(24, 26, 4, 32, 34, 28); gr.addColorStop(0, '#FFD08A'); gr.addColorStop(1, '#F07F5A');
        g.fillStyle = gr; g.beginPath(); g.arc(32, 35, 22, 0, 7); g.fill();
        g.strokeStyle = 'rgba(190,80,60,.5)'; g.lineWidth = 1.6; g.beginPath(); g.moveTo(32, 14); g.bezierCurveTo(26, 28, 28, 46, 32, 56); g.stroke();
        g.fillStyle = '#5FAE6E'; g.beginPath(); g.ellipse(40, 12, 9, 4, -.4, 0, 7); g.fill();
      }),
      rose: mk((g) => {
        g.translate(32, 32);
        g.fillStyle = '#C2304E'; g.beginPath(); g.arc(0, 0, 24, 0, 7); g.fill();
        g.fillStyle = '#DB4E6A'; for (let i = 0; i < 6; i++) { g.save(); g.rotate(i * 1.05); g.beginPath(); g.ellipse(0, -12, 10, 13, 0, 0, 7); g.fill(); g.restore(); }
        g.strokeStyle = '#8E1F38'; g.lineWidth = 2.2; g.beginPath(); for (let a = 0; a < 12; a += .2) { const r = 1 + a * 1.3; g.lineTo(Math.cos(a) * r, Math.sin(a) * r); } g.stroke();
      }),
      jasmine: mk((g) => {
        g.translate(32, 32); g.fillStyle = '#FFFFFF'; g.strokeStyle = 'rgba(200,190,170,.9)'; g.lineWidth = 1.4;
        for (let i = 0; i < 5; i++) { g.save(); g.rotate(i * Math.PI * 2 / 5); g.beginPath(); g.ellipse(0, -16, 7, 15, 0, 0, 7); g.fill(); g.stroke(); g.restore(); }
        g.fillStyle = '#F2D36B'; g.beginPath(); g.arc(0, 0, 4.5, 0, 7); g.fill();
      }),
      violet: mk((g) => {
        g.translate(32, 34); g.fillStyle = '#7B5AAE';
        [[0, -15, 9, 12], [-13, -4, 10, 9], [13, -4, 10, 9], [-8, 11, 9, 9], [8, 11, 9, 9]].forEach(([x, y, rx, ry]) => { g.beginPath(); g.ellipse(x, y, rx, ry, 0, 0, 7); g.fill(); });
        g.fillStyle = '#F6D36B'; g.beginPath(); g.arc(0, 1, 4, 0, 7); g.fill();
      }),
      vanilla: mk((g) => {
        g.strokeStyle = '#4A2A16'; g.lineWidth = 5; g.lineCap = 'round'; g.beginPath(); g.moveTo(12, 54); g.quadraticCurveTo(30, 34, 52, 14); g.stroke();
        g.translate(44, 40); g.fillStyle = '#FFF4D6';
        for (let i = 0; i < 5; i++) { g.save(); g.rotate(i * Math.PI * 2 / 5); g.beginPath(); g.ellipse(0, -9, 5, 10, 0, 0, 7); g.fill(); g.restore(); }
        g.fillStyle = '#F2C94C'; g.beginPath(); g.arc(0, 0, 3.5, 0, 7); g.fill();
      }),
      coffee: mk((g) => {
        g.translate(32, 32); g.rotate(.5);
        g.fillStyle = '#6B3E22'; g.beginPath(); g.ellipse(0, 0, 16, 24, 0, 0, 7); g.fill();
        g.strokeStyle = '#2E1608'; g.lineWidth = 3; g.beginPath(); g.moveTo(-2, -20); g.bezierCurveTo(6, -6, -6, 6, 2, 20); g.stroke();
        g.fillStyle = 'rgba(255,255,255,.2)'; g.beginPath(); g.ellipse(-7, -8, 3, 8, 0, 0, 7); g.fill();
      }),
      amber: mk((g) => {
        const gr = g.createRadialGradient(26, 26, 2, 32, 34, 26); gr.addColorStop(0, '#FFD98A'); gr.addColorStop(1, '#C8762A');
        g.fillStyle = gr; g.beginPath(); g.moveTo(32, 8); g.bezierCurveTo(48, 26, 54, 38, 32, 56); g.bezierCurveTo(10, 38, 16, 26, 32, 8); g.fill();
        g.fillStyle = 'rgba(255,255,255,.5)'; g.beginPath(); g.ellipse(26, 30, 3, 6, 0, 0, 7); g.fill();
      }),
      spark: mk((g) => {
        g.translate(32, 32); g.fillStyle = '#FFF4C2';
        g.beginPath(); for (let i = 0; i < 8; i++) { const r = i % 2 ? 6 : 28, a = i * Math.PI / 4; g.lineTo(Math.cos(a) * r, Math.sin(a) * r); } g.closePath(); g.fill();
      }),
    };
    let accents = [];
    const states = flasks.map((el, i) => ({ el, d: DATA[i], spr: DATA[i].hl ? SPR.amber : SPR.gold }));
    let parts = [], clouds = [], W = 0, H = 0;
    function resize() {
      const r = cv.getBoundingClientRect();
      cv.width = r.width * DPR; cv.height = r.height * DPR; W = r.width; H = r.height;
      states.forEach((s) => {
        const b = s.el.querySelector('svg.fl-bottle').getBoundingClientRect();
        const sv = s.el.querySelector('svg.fl-bottle');
        s.nx = b.left - r.left + b.width * Number(sv.dataset.nx) / 80;   // Duese laut data-nx/ny (viewBox 80x150)
        s.ny = b.top - r.top + b.height * Number(sv.dataset.ny) / 150;
        s.dir = Number(sv.dataset.dir || 1);
        s.up = Number(sv.dataset.up || 0);
      });
    }
    window.addEventListener('resize', resize);
  
    // jeder Flakon wird einmal gedrueckt
    function press(s) { spray(s); }
    const hlState = () => states.find((x) => x.d.hl) || states[states.length - 1];
    function spray(s) {
      resize();
      const k = strength(s.d);
      s.el.classList.add('is-press');
      setTimeout(() => s.el.classList.remove('is-press'), 170);
      const n = Math.round(90 + 520 * k);            // Cologne ~ 160, Olfazeta ~ 610 Troepfchen
      const reach = (0.5 + 1.15 * k) * (Number(root.dataset.flReach) || 1);   // Reichweite (im Rahmen kleiner)
      const life = 0.6 + 2.8 * k;                    // Sekunden in der Luft
      for (let j = 0; j < n; j++) {
        const a = (Math.random() - .5) * (0.35 + 0.45 * k) - 0.08 - s.up;   // Kegel leicht nach oben
        const v = (70 + Math.random() * 170) * reach;
        parts.push({ s, x: s.nx, y: s.ny, vx: Math.cos(a) * v * s.dir, vy: Math.sin(a) * v,
          r: 1.4 + Math.random() * (2 + 4 * k), life: life * (0.55 + Math.random() * 0.7),
          age: -Math.random() * 0.14, a: 0.14 + 0.36 * k });
      }
      // Inhalt des Spruehstosses
      const hl = !!s.d.hl;
      const emit = (kinds, m, delay, lifeMul, big) => {
        for (let j = 0; j < m; j++) {
          const kind = kinds[j % kinds.length];
          const a = (Math.random() - .5) * (0.5 + 0.5 * k) - 0.05;
          const v = (50 + Math.random() * 120) * (0.6 + k) * (Number(root.dataset.flReach) || 1);
          accents.push({ s, kind, x: s.nx + 4, y: s.ny, vx: Math.cos(a) * v, vy: Math.sin(a) * v,
            rot: Math.random() * 6.3, vr: (Math.random() - .5) * 3, size: (big ? 12 : 7) + Math.random() * (big ? 10 : 6),
            life: (1.2 + 2.6 * k) * lifeMul * (0.75 + Math.random() * 0.5), age: -delay - Math.random() * 0.2 });
        }
      };
      if (hl) {
        // Nr. 141 Sands of Time: erst die Kopfnote, dann das Herz, zuletzt die Basis (bleibt am laengsten)
        emit(['pineapple', 'strawberry', 'apple', 'orange', 'peach'], 8, 0, 0.8, true);       // Kopf: Ananas, Erdbeere, Apfel, Suessorange, Pfirsich
        emit(['rose', 'jasmine', 'violet', 'petal'], 6, 0.3, 1.0, true);                      // Herz: Damaszener Rose, Jasmin, Veilchen
        emit(['vanilla', 'coffee', 'amber'], 5, 0.6, 1.3, true);                             // Basis: Vanille, Kaffee, Ambra/Harze
        emit(['spark'], 3, 0.1, 0.8, true);
      } else {
        emit(['lemon', 'orange', 'berry', 'blossom', 'leaf'].sort(() => Math.random() - .5), Math.round(1 + 6 * k * k), 0, 1, false);
      }
      // Duftwolke: waechst, treibt nach rechts oben und bleibt je nach Anteil laenger stehen
      clouds.push({ s, x: s.nx + 26 * s.dir * (s.up ? 0.6 : 1), y: s.ny - 22 * s.up, r: 14, grow: (26 + 64 * k) * (Number(root.dataset.flReach) || 1), a: 0.08 + 0.16 * k, life: 1.2 + 4.2 * k, age: 0 });
    }
  
    let last = performance.now();
    function tick(now) {
      const dt = Math.min(0.05, (now - last) / 1000); last = now;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      ctx.clearRect(0, 0, W, H);
      clouds = clouds.filter((c) => {
        c.age += dt; if (c.age > c.life) return false;
        const t = c.age / c.life;
        c.x += 14 * dt * c.s.dir * (c.s.up ? 0.4 : 1); c.y -= (6 + 30 * c.s.up) * dt; c.r += c.grow * dt * (1 - t);
        ctx.globalAlpha = c.a * (t < 0.15 ? t / 0.15 : 1 - (t - 0.15) / 0.85);
        ctx.drawImage(c.s.spr, c.x - c.r, c.y - c.r, c.r * 2, c.r * 2);
        return true;
      });
      parts = parts.filter((p) => {
        p.age += dt;
        if (p.age < 0) return true;
        if (p.age > p.life) return false;
        p.vx *= Math.pow(0.16, dt); p.vy = p.vy * Math.pow(0.22, dt) + 5 * dt;  // abbremsen, leicht absinken
        p.x += p.vx * dt; p.y += p.vy * dt;
        const t = p.age / p.life;
        ctx.globalAlpha = Math.max(0, p.a * (t < 0.08 ? t / 0.08 : 1 - (t - 0.08) / 0.92));
        const r = p.r * (1 + t * 1.8);
        ctx.drawImage(p.s.spr, p.x - r, p.y - r, r * 2, r * 2);
        return true;
      });
      // Frische-Akzente
      accents = accents.filter((a) => {
        a.age += dt; if (a.age < 0) return true; if (a.age > a.life) return false;
        a.vx *= Math.pow(0.3, dt); a.vy = a.vy * Math.pow(0.3, dt) - 8 * dt;   // schweben leicht nach oben
        a.x += a.vx * dt; a.y += a.vy * dt; a.rot += a.vr * dt;
        const t = a.age / a.life;
        ctx.globalAlpha = (t < 0.12 ? t / 0.12 : 1 - (t - 0.12) / 0.88) * (a.kind === 'spark' ? 0.95 : 0.9);
        const sz = a.size * (a.kind === 'spark' ? 0.8 + 0.4 * Math.sin(a.age * 9) : 1);
        ctx.save(); ctx.translate(a.x, a.y); ctx.rotate(a.rot);
        ctx.drawImage(FRESH[a.kind], -sz / 2, -sz / 2, sz, sz);
        ctx.restore();
        return true;
      });
      ctx.globalAlpha = 1;
      requestAnimationFrame(tick);
    }
  
    /* ---------- Fuellen, Zaehler, Ablauf ---------- */
    function fill() {
      states.forEach((s, i) => {
        setTimeout(() => {
          s.el.querySelector('.fl-liquid').style.transform = 'scaleY(1)';
          s.el.querySelector('.fl-meter i').style.width = (s.d.to / MAX * 100) + '%';
          count(s.el.querySelector('[data-pct]'), s.d);
        }, i * 180);
      });
    }
    function count(el, d) {
      const t0 = performance.now(), dur = 1400;
      const step = (now) => {
        const t = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - t, 3);
        const v = Math.round(d.to * e);
        el.textContent = d.hl ? `bis ${v} %` : `${Math.round(d.from * e)}\u2013${v} %`;
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));
    let running = false;
    async function sequence() {
      if (running) return; running = true;
      try {
      for (const s of states) { press(s); await wait(650); }
      hlState().el.classList.add('is-done');
      } finally { running = false; }
    }
    function together() { states.forEach((s) => press(s)); hlState().el.classList.add('is-done'); }
  
    flasks.forEach((el, i) => {
      const go = () => press(states[i]);
      el.addEventListener('click', go);
      el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
    });
  
    // Start, sobald der Bereich sichtbar ist
    resize();
    requestAnimationFrame(tick);
    // Szene abspielen: Intro -> zur Seite -> Ueberschrift -> Flakons -> fuellen -> spruehen
    const scene = root;
    let timers = [];
    const at = (ms, fn) => timers.push(setTimeout(fn, ms));
    function reset() {
      timers.forEach(clearTimeout); timers = [];
      scene.classList.remove('fl-s1', 'fl-s2', 'fl-s3', 'fl-s4', 'fl-s5');
      states.forEach((s) => {
        s.el.classList.remove('is-done');
        s.el.querySelector('.fl-liquid').style.transform = '';
        s.el.querySelector('.fl-meter i').style.width = '0';
        s.el.querySelector('[data-pct]').textContent = '0 %';
      });
      parts = []; clouds = []; accents = [];
    }
    function play() {
      reset();
      void scene.offsetWidth;
      at(100, () => scene.classList.add('fl-s1'));            // "Warum Olfazeta?" erscheint gross
      at(2000, () => scene.classList.add('fl-s2'));           // gleitet zur Seite
      at(2600, () => scene.classList.add('fl-s3'));           // Ueberschrift + Text
      at(3700, () => scene.classList.add('fl-s4'));           // Flakons steigen auf
      at(4500, () => { resize(); fill(); });               // fuellen + Prozente zaehlen
      at(6300, () => { sequence().then(() => scene.classList.add('fl-s5')); });  // spruehen, danach Knoepfe
    }
    new IntersectionObserver((es, io) => {
      if (es.some((e) => e.isIntersecting)) { io.disconnect(); play(); }
    }, { threshold: 0.35 }).observe(scene);
  
  }
  document.querySelectorAll('[data-fl-scene]').forEach(init);
  window.SZFlakonScene = init;
})();
